import { FeelNumberEntry } from '@bpmn-io/properties-panel';
import { withTooltipContainer, withVariableContext } from '../provider/HOCs';

export const BpmnFeelNumberEntry = withVariableContext(withTooltipContainer(FeelNumberEntry));
